var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Container, Grid, Cell, Image } from "./styled/photo-card-photos";
function PhotoCardPhotos(_a) {
    var photos = _a.photos, props = __rest(_a, ["photos"]);
    return (React.createElement(Container, __assign({}, props),
        React.createElement(Grid, null, photos.map(function (image, index) { return (React.createElement(Cell, { key: index },
            React.createElement(Image, { style: { backgroundImage: "url('" + image + "')" } }))); }))));
}
export default PhotoCardPhotos;
